<template>
  <div>
    <v-dialog v-model="dialog" scrollable width="950">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" depressed color="chip" small>
          <div class="text-capitalize">Görüntüle</div>
        </v-btn>
      </template>

      <v-card
        :class="{
          'scrollable-card': !isScroll,
          'scrollable-not-card': !isScroll && arrivedState.bottom,
        }"
      >
        <v-card-title class="grey">
          <div
            class="d-flex align-center justify-space-between"
            style="width: 100%"
          >
            <div class="d-flex align-center title-left">
              <v-icon color="white" :size="$vuetify.breakpoint.xsOnly ? 28 : 48">
                {{ icons.mdiFileDocument }}
              </v-icon>

              <div
                class="title-text ms-3 white--text"
                :class="$vuetify.breakpoint.xsOnly ? 'text-body-2' : 'text-h5 font-weight-bold'"
                :title="formData.product_name + ' - Tedarikçi Onay Formu'"
              >
                {{ formData.product_name }} - Tedarikçi Onay Formu
              </div>
            </div>
            <v-btn color="grey" depressed fab @click="closeForm()">
              <v-icon large>
                {{ icons.mdiCloseCircleOutline }}
              </v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <!-- Durum bilgisi - sabit (scroll'da kaymaz) -->
        <div class="pa-4">
          <v-alert class="ma-0" :type="getStatusColor(formData.status)" outlined>
            <div class="font-weight-bold">
              {{formData.statustxt }}
            </div>
          </v-alert>
        </div>

        <v-divider />

        <v-card-text class="pa-0" ref="scrollableEl" style="height: 100svh">
          <!-- Form Bilgileri -->
          <v-container class="py-4">

            <v-row>
              <v-col cols="12" md="6">
                <div class="form-field">
                  <div class="form-label font-weight-bold">Dokuman No</div>
                  <div class="form-value">{{ formData.docnum }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-field">
                  <div class="form-label font-weight-bold">Revizyon No</div>
                  <div class="form-value">{{ formData.revnum }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-field">
                  <div class="form-label font-weight-bold">Yayın Tarihi</div>
                  <div class="form-value">{{ formData.publish_date | moment("DD.MM.YYYY") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-field">
                  <div class="form-label font-weight-bold">Revizyon Tarihi</div>
                  <div class="form-value">{{ formData.rev_date | moment("DD.MM.YYYY") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-field">
                  <div class="form-label font-weight-bold">Ürün Adı</div>
                  <div class="form-value">{{ formData.product_name }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-field">
                  <div class="form-label font-weight-bold">Hazırlanma Tarihi</div>
                  <div class="form-value">{{ formData.prepared_date | moment("DD.MM.YYYY") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-field">
                  <div class="form-label font-weight-bold">Formu Dolduran</div>
                  <div class="form-value">{{ formData.form_filler }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-field">
                  <div class="form-label font-weight-bold">Tedarikçi Adı</div>
                  <div class="form-value">{{ formData.supplier_name }}</div>
                </div>
              </v-col>
            </v-row>
          </v-container>

          <v-divider />

          <!-- Alerjen Tablosu -->
          <div v-if="formData.allergensData && formData.allergensData.length" class="pa-4">
            <div class="text-h6 font-weight-bold mb-4">Alerjen Tablosu</div>

            <!-- Masaüstü görünümü -->
            <div v-show="$vuetify.breakpoint.smAndUp">
              <v-simple-table dense class="allergen-table">
                <thead>
                  <tr>
                    <th class="text-left">Soru</th>
                    <th class="text-left">Bileşenler</th>
                    <th class="text-left">Hariç tutulan ürünler</th>
                    <th class="text-left">Üründe Bulunur</th>
                    <th class="text-left">Aynı Hatta Üretilen Diğer Ürünlerde Bulunabilir</th>
                    <th class="text-left">Aynı Bölümde Kullanılmakta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in formData.allergensData" :key="`a-${item.id}`">
                    <td>{{ item.id }}</td>
                    <td>{{ getAllergenName(item.id) }}</td>
                    <td>{{ getAllergenExcluded(item.id) }}</td>
                    <td>{{ item.inProduct === 'E' ? 'Evet' : 'Hayır' }}</td>
                    <td>{{ item.sameLine === 'E' ? 'Evet' : 'Hayır' }}</td>
                    <td>{{ item.sameSection === 'E' ? 'Evet' : 'Hayır' }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>

            <!-- Mobil görünüm -->
            <div v-show="$vuetify.breakpoint.xsOnly">
              <v-card v-for="item in formData.allergensData" :key="`am-${item.id}`"
                     class="mb-3 pa-3" outlined>
                <div class="d-flex justify-space-between align-center mb-2">
                  <div class="text-subtitle-1 font-weight-bold blue--text">Alerjen #{{ item.id }}</div>
                </div>
                <v-divider class="mb-3" />
                <div class="allergen-item">
                  <div class="allergen-label font-weight-bold">Bileşenler</div>
                  <div class="allergen-value">{{ getAllergenName(item.id) }}</div>
                </div>
                <div class="allergen-item">
                  <div class="allergen-label font-weight-bold">Hariç Tutulan Ürünler</div>
                  <div class="allergen-value">{{ getAllergenExcluded(item.id) }}</div>
                </div>
                <div class="allergen-item">
                  <div class="allergen-label font-weight-bold">Üründe Bulunur</div>
                  <div class="allergen-value">{{ item.inProduct === 'E' ? 'Evet' : 'Hayır' }}</div>
                </div>
                <div class="allergen-item">
                  <div class="allergen-label font-weight-bold">Aynı Hatta Üretilen Diğer Ürünlerde Bulunabilir</div>
                  <div class="allergen-value">{{ item.sameLine === 'E' ? 'Evet' : 'Hayır' }}</div>
                </div>
                <div class="allergen-item">
                  <div class="allergen-label font-weight-bold">Aynı Bölümde Kullanılmakta</div>
                  <div class="allergen-value">{{ item.sameSection === 'E' ? 'Evet' : 'Hayır' }}</div>
                </div>
              </v-card>
            </div>
          </div>

          <v-divider />

          <!-- Yüklenen Dosyalar -->
          <div class="pa-4">
            <div class="text-h6 font-weight-bold mb-4 blue--text">Yüklenen Belgeler</div>

            <!-- Belgeleri türlerine göre grupla -->
            <div v-for="(group, docType) in groupedDocuments" :key="docType" class="mb-4">
              <div class="subtitle-1 font-weight-bold mb-3 pa-2 blue-grey lighten-5 rounded">{{ getDocTitle(docType) }}</div>
              <v-row dense>
                <v-col v-for="(medya, i) in group" :key="`${docType}-${i}`" cols="6" md="6" sm="6" class="mb-2">
                    <v-card outlined class="doc-card" height="100%">
                    <!-- Resim dosyaları için -->
                    <div v-if="isImage(medya.dosya_tipi)" @click="showImageDialog(medya.dosya_adi)" style="cursor: pointer">
                      <v-img
                        :src="medya.dosya_adi"
                        height="140"
                        contain
                        class="px-2 pt-2 thumbnail-img"
                      />
                      <div class="px-2 pb-1 pt-1 text-caption text-center text-truncate">
                        {{ medya.gdosya_adi || 'Resim' }}
                      </div>
                    </div>

                    <!-- PDF dosyaları için -->
                    <div v-else-if="isPDF(medya.dosya_tipi)" @click="showFileDialog(medya)" class="cursor-pointer">
                      <div class="d-flex align-center justify-center pt-2" style="height: 140px">
                        <v-icon size="56" color="error">{{ icons.mdiFilePdfBox }}</v-icon>
                      </div>
                      <div class="px-2 pb-1 text-caption text-center text-truncate">
                        {{ medya.gdosya_adi || 'PDF Dosyası' }}
                      </div>
                    </div>

                    <!-- Diğer dosya tipleri için -->
                    <div v-else @click="showFileDialog(medya)" class="cursor-pointer">
                      <div class="d-flex align-center justify-center pt-2" style="height: 140px">
                        <v-icon size="56">{{ icons.mdiFile }}</v-icon>
                      </div>
                      <div class="px-2 pb-1 text-caption text-center text-truncate">
                        {{ medya.gdosya_adi || 'Dosya' }}
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="group.length === 0" class="text-center grey--text ma-0 pa-0">
                <v-col cols="12">Belge bulunmuyor</v-col>
              </v-row>
            </div>

            <!-- Belge yoksa -->
            <div v-if="!formData.medyalar || formData.medyalar.length === 0" class="text-center py-4">
              Yüklenmiş belge bulunmamaktadır
            </div>
          </div>
        </v-card-text>

        <!-- Yüklenen Belgeler altı - Açıklama (ltext) -->
        <v-divider />
        <div v-if="!showApproveButton || !showCancelButton" class="pa-4 pt-0">
          <v-textarea
            :value="data.ltext"
            label="Açıklama"
            outlined
            auto-grow
            rows="2"
            hide-details="auto"
            readonly
          />
        </div>


        <!-- Onay için veya Reddet için Açıklama Alanı -->
        <div v-if="showApproveButton || showCancelButton" class="pa-4 pt-0">
          <v-textarea
            v-model="description"
            label="Açıklama"
            outlined
            auto-grow
            rows="2"
            :rules="[v => !!(v && v.trim()) || 'Açıklama zorunludur']"
            hide-details="auto"
          />
        </div>

        <!-- Onay ve Reddet Butonları -->
        <v-card-actions v-if="showApproveButton || showCancelButton" class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            v-if="showApproveButton"
            color="success"
            large
            rounded
            elevation="2"
            :loading="approving"
            @click="handleApprove"
            class="text-capitalize px-6 py-2"
          >
            <v-icon left>{{ icons.mdiCheckCircle }}</v-icon>
            <span class="font-weight-medium">Onayla</span>
          </v-btn>
          <v-btn
            v-if="showCancelButton"
            color="error"
            large
            rounded
            elevation="2"
            :loading="rejecting"
            @click="handleReject"
            class="text-capitalize ml-4 px-6 py-2"
          >
            <v-icon left>{{ icons.mdiCloseCircle }}</v-icon>
            <span class="font-weight-medium">Reddet</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Resim Görüntüleme Dialog -->
    <v-dialog
      v-model="imageDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :max-width="$vuetify.breakpoint.xsOnly ? '100%' : '90vw'"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title :class="$vuetify.breakpoint.xsOnly ? 'primary white--text' : 'grey lighten-2'">
          <span class="text-h6">Resim Görüntüleyici</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="imageDialog = false" :color="$vuetify.breakpoint.xsOnly ? 'white' : ''">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <div class="text-center image-container">
            <v-img
              :src="currentImageUrl"
              :max-height="$vuetify.breakpoint.xsOnly ? '85vh' : '80vh'"
              contain
              class="mx-auto"
            ></v-img>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  <!-- Bu dialog artık kullanılmıyor -->
  </div>
</template>

<script>
import { ref, watch, computed } from "vue-demi";

// Utils
import { useScroll, useResizeObserver } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";
import { useAllergenStore } from "@/stores/allergen";
import { postData } from "@utils";
import Vue from 'vue';


// Icons
import {
  mdiFileDocument,
  mdiCloseCircleOutline,
  mdiOpenInNew,
  mdiFilePdfBox,
  mdiFile,
  mdiClose,
  mdiDownload,
  mdiCheckCircle,
  mdiAlertCircle,
  mdiCloseCircle
} from "@mdi/js";

export default {
  props: {
    data: Object,
    showApproveButton: Boolean,
    showCancelButton: Boolean
  },
  setup(props, { emit }) {
    const toast = useToast();

    const dialog = ref(false);

    // Kaydırma çubuğu
    const scrollableEl = ref(null);
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, () => {
      isScroll.value =
        scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
    });

    const closeForm = () => {
      dialog.value = false;
      description.value = '';
    };

    const openUrl = (url) => {
      window.open(url, "_blank");
    };

    // Resim ve dosya görüntüleme dialogları
    const imageDialog = ref(false);
    const fileDialog = ref(false);
    const currentImageUrl = ref('');
    const currentFile = ref(null);

    const showImageDialog = (url) => {
      currentImageUrl.value = url;
      imageDialog.value = true;
    };

    const showFileDialog = (file) => {
      currentFile.value = file;

      // Eğer resimse resim dialogunda göster
      if (isImage(file.dosya_tipi)) {
        currentImageUrl.value = file.dosya_adi;
        imageDialog.value = true;
      } else {
        // Resim değilse doğrudan yeni pencerede aç
        openUrl(file.dosya_adi);
      }
    };

    // Dosya uzantısını alma
    const getFileType = (url) => {
      if (!url) return '';
      const extension = url.split('.').pop().toLowerCase();

      // İlk denemede başarısızsa dosya adından başka yöntemle uzantı çıkarmayı dene
      if (!extension || extension === url.toLowerCase()) {
        // Eğer dosya adında "png" geçiyorsa png olarak varsay
        if (url.toLowerCase().includes('png')) return 'png';
        if (url.toLowerCase().includes('jpg') || url.toLowerCase().includes('jpeg')) return 'jpg';
        if (url.toLowerCase().includes('pdf')) return 'pdf';
      }

      return extension;
    };

    const formData = ref({});

    // Buton görünürlük ve loading state'leri
    const approving = ref(false);
    const rejecting = ref(false);
    const description = ref('');

    // Onay işlemi
    const handleApprove = async () => {
      if (approving.value) return;

      if (!description.value || !description.value.trim()) {
        toast.error('Açıklama zorunludur');
        return;
      }

      const swalResult = await Vue.swal({
        title: 'Emin misiniz?',
        text: 'Bu formu onaylamak istediğinizden emin misiniz?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet, Onayla',
        cancelButtonText: 'Vazgeç',
      });

      if (!swalResult || !swalResult.isConfirmed) return;

      approving.value = true;
      try {
        const response = await postData({
          method: "vendorFormOperations",
          func: "updateStatus",
          id: formData.value.id,
          status: "APR",
          description: description.value,
        });

        if (response && Number(response.error) === 0) {
          toast.success(response.msg || "Form onaylandı.");
          closeForm();
          // Üst bileşene başarı bilgisini gönder
          emit('updated', { id: formData.value.id, status: 'APR' });
        } else {
          toast.error((response && response.msg) || "Onay işlemi başarısız oldu");
        }
      } catch (e) {
        toast.error(`Hata: ${e.message}`);
      } finally {
        approving.value = false;
      }
    };

    // Reddet işlemi
    const handleReject = async () => {
      if (rejecting.value) return;

      if (!description.value || !description.value.trim()) {
        toast.error('Açıklama zorunludur');
        return;
      }

      const swalResult = await Vue.swal({
        title: 'Emin misiniz?',
        text: 'Bu formu reddetmek istediğinizden emin misiniz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, Reddet',
        cancelButtonText: 'Vazgeç',
      });

      if (!swalResult || !swalResult.isConfirmed) return;

      rejecting.value = true;
      try {
        const response = await postData({
          method: "vendorFormOperations",
          func: "updateStatus",
          id: formData.value.id,
          status: "CNC",
          description: description.value,
        });

        if (response && Number(response.error) === 0) {
          toast.success(response.msg || "Form reddedildi.");
          closeForm();
          // Üst bileşene başarı bilgisini gönder
          emit('updated', { id: formData.value.id, status: 'CNC' });
        } else {
          toast.error((response && response.msg) || "Reddetme işlemi başarısız oldu");
        }
      } catch (e) {
        toast.error(`Hata: ${e.message}`);
      } finally {
        rejecting.value = false;
      }
    };

    // Belgeleri türlerine göre gruplama ve doğru sırada gösterme
    const groupedDocuments = computed(() => {
      if (!formData.value.medyalar) return {};

      const groups = {};
      formData.value.medyalar.forEach(medya => {
        if (!groups[medya.tur]) {
          groups[medya.tur] = [];
        }
        groups[medya.tur].push(medya);
      });

      // Doğru sırada göstermek için sıralama fonksiyonu
      const docOrder = {
        'isletmeKayit': 1,
        'urunSpes': 2,
        'kaliteBelgesi': 3,
        'guncelAnaliz': 4,
        'taklitTagsis': 5,
        'radyoaktivite': 6,
        'gdo': 7,
        'helal': 8
      };

      // Sıralı grupları döndür
      const sortedGroups = {};
      Object.keys(groups)
        .sort((a, b) => (docOrder[a] || 999) - (docOrder[b] || 999))
        .forEach(key => {
          sortedGroups[key] = groups[key];
        });

      return sortedGroups;
    });

    // Allergen store kullanımı
    const allergenStore = useAllergenStore();

    // Alerjen adını alma
    const getAllergenName = (id) => {
      return allergenStore.getAllergenName(id);
    };

    // Hariç tutulan ürünleri alma
    const getAllergenExcluded = (id) => {
      return allergenStore.getAllergenExcluded(id);
    };

    // Komponent oluşturulduğunda alerjen verilerini yükle
    allergenStore.fetchAllergenData();

    // Belge başlığını getir
    const docTypeTitles = {
      isletmeKayit: "1. İşletme kayıt belgesi",
      urunSpes: "2. Ürün spesifikasyonu",
      kaliteBelgesi: "3. Kalite belgesi",
      guncelAnaliz: "4. Güncel ürün analizi",
      taklitTagsis: "5. Taklit tağşiş deklarasyonları",
      radyoaktivite: "6. Radyoaktivite deklarasyonları",
      gdo: "7. GDO deklarasyonu",
      helal: "8. Helal belgesi"
    };

    const getDocTitle = (type) => {
      return docTypeTitles[type] || type;
    };

    const isPDF = (fileType) => {
      return fileType === 'pdf';
    };

    const isImage = (fileType) => {
      if (!fileType) return false;

      // Önce dosya adındaki uzantıyı kontrol et
      if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType.toLowerCase())) {
        return true;
      }

      // PNG dosyalarını tespit etmek için ek kontrol
      if (typeof fileType === 'string' && fileType.toLowerCase().includes('png')) {
        return true;
      }

      // Kısmi eşleşmeleri kontrol et
      const imageTypes = ['image', 'img', 'resim', 'picture', 'foto'];
      for (let type of imageTypes) {
        if (typeof fileType === 'string' && fileType.toLowerCase().includes(type)) {
          return true;
        }
      }

      return false;
    };

    watch(dialog, (val) => {
      if (val) {
        formData.value = { ...props.data };
        description.value = '';

        // JSON string'i parse et
        if (typeof formData.value.allergens === 'string') {
          try {
            formData.value.allergensData = JSON.parse(formData.value.allergens);
          } catch (e) {
            formData.value.allergensData = [];
            console.error("Alerjen verilerini ayrıştırma hatası:", e);
          }
        }

        isScroll.value =
          scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
      }
    });

    // Durum bilgisi için doğrudan status değerini kullan
    const getStatusText = (status) => {
      if (!status) return 'Statü Yok';
      if (status === 'WAIT') return 'Bekliyor';
      if (status === 'CNC') return 'Reddedildi';
      if (status === 'APR') return 'Kabul edildi';
      return 'Statü Yok';
    };

    const getStatusColor = (status) => {
      if (!status) return 'warning';
      // Status değerine göre renk belirle
      if (status === 'WAIT') return 'warning';
      if (status === 'CNC') return 'error';
      if (status === 'APR') return 'success';
      return 'warning';
    };

    return {
      dialog,
      formData,
      isScroll,
      arrivedState,
      scrollableEl,
      closeForm,
      openUrl,
      getDocTitle,
      isPDF,
      isImage,
      getAllergenName,
      getAllergenExcluded,
      groupedDocuments,
      imageDialog,
      fileDialog,
      currentFile,
      currentImageUrl,
      showImageDialog,
      showFileDialog,
      getFileType,
      getStatusText,
      getStatusColor,
      approving,
      rejecting,
      handleApprove,
      handleReject,
      description,
      icons: {
        mdiFileDocument,
        mdiCloseCircleOutline,
        mdiOpenInNew,
        mdiFilePdfBox,
        mdiFile,
        mdiClose,
        mdiDownload,
        mdiCheckCircle,
        mdiAlertCircle,
        mdiCloseCircle
      },
    };
  },
};
</script>

<style scoped>
.scrollable-card {
  height: auto !important;
  max-height: 90vh;
}
.scrollable-text-card {
  height: auto !important;
  max-height: 90vh;
}
.scrollable-not-card {
  height: auto !important;
  max-height: none;
}
.doc-card {
  transition: all 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
}
.doc-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
  border-color: #1976d2;
}
.thumbnail-img {
  cursor: pointer;
}

.image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.05);
}
.cursor-pointer {
  cursor: pointer;
}
.form-field {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 100%;
}
.form-label {
  color: #42a5f5;
  margin-bottom: 8px;
  font-size: 0.9rem;
}
.form-value {
  font-size: 1.1rem;
  text-align: center;
}
.allergen-item {
  margin-bottom: 16px;
}
.allergen-label {
  color: #42a5f5;
  font-size: 0.9rem;
  margin-bottom: 4px;
}
.allergen-value {
  padding-left: 8px;
  font-size: 0.95rem;
}

/* Title responsive tweaks */
.title-left {
  flex: 1;
  min-width: 0; /* allow child to truncate */
}
.title-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
